module.exports = __webpack_public_path__ + "static/media/blue-guy.f250e224.svg";